import _ from 'lodash';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import i18n, { i18n_t } from '@/locales/i18n';
dayjs.extend(duration);
/**
 * 计算剩余时间
 * @param speed 网速 单位 b/s
 * @param total 总大小 单位 b
 * @param percent 百分比 [0,1]
 * 根据 三要素来进行计算
 * multiply 乘法
 * subtract 减法
 * add 加法
 * divide 除法
 * round 精度
 */
export const calcRemainingTime = (speed: number, total: number, percent: number) => {
  const CALCULATE = i18n_t('计算中');
  // 速度不准确 直接返回
  if (speed === 0) {
    return {
      remainingTime: 0,
      remainingMessage: CALCULATE,
    };
  }
  const lodash = _;
  // 剩余大小 单位b
  const remainingSize = lodash.subtract(total, percent);
  // 剩余时间计算 单位 s
  const remainingTime: number = lodash.round(lodash.divide(remainingSize, speed));
  // 剩余时间计算结果 '00:03:10' | '大于一天'
  let remainingMessage = CALCULATE;
  remainingMessage = calcRemainingMessageBySeconds(remainingTime);
  return {
    remainingMessage,
    remainingTime,
  };
};
/**
 * 根据毫秒数计算出来一个合适的message
 * 若超过1天，则为'超过一天'
 * @param seconds
 */
export const calcRemainingMessageBySeconds = (seconds: number) => {
  const ONE_DAY = 24 * 60 * 60 * 1000;
  if (seconds >= ONE_DAY) {
    return i18n_t('大于一天');
  }
  return dayjs.duration(seconds, 'seconds').format('HH:mm:ss');
};
